import { AllService, PaginateService, DeleteService, GetService, PostService, PutService, CloneService } from "../services";
import {setUriParams} from "@/utils/helpers"

export default {
  async all({commit}, params = {}){
    try {
      commit("SET_LOADING", {all: true})
      const data = await AllService(params);
      commit("SET_ALL_ROWS", data)
      commit("SET_LOADING", {all: false})
      return Promise.resolve();
    } catch (e) {
      commit("SET_ALL_ROWS")
      commit("SET_LOADING", {all: false})
      return Promise.resolve();
    }
  },
  async paginate({commit, getters}, {url, params = {}} = {}){
    try {
      commit("SET_FILTER", params);
      setUriParams(getters.filter)
      const {data, ...p} = await PaginateService(url, getters.filter);
      commit("SET_ROWS", data)
      commit("SET_PAGINATION", p)
      return Promise.resolve();
    } catch (e) {
      commit("SET_ROWS")
      return Promise.resolve();
    }
  },
  async get({commit, getters}, payload){
    try {
      if(getters.row && Number(getters.row.id) === Number(payload)) {
        return Promise.resolve();
      }
      // 
      const data = await GetService(payload);
      commit("SET_ROW", data)
      return Promise.resolve(data);
    } catch (e) {
      commit("SET_ROW")
      return Promise.reject(e);
    }
  },
  async save({commit, dispatch}, payload){
    try {
      const $http = !payload.id ? PostService : PutService
      const data = await $http(payload);
      commit("SET_UPDATE_ROW", data)
      dispatch("all",{id_padre: data.id_padre})
      dispatch("form_1617206897966/all", true,{root:true})
      return Promise.resolve(data);
    } catch (e) {
      return Promise.resolve(null);
    }
  },
  async clone({dispatch}, payload){
    try {
      const data = await CloneService(payload);
      dispatch("form_1617206897966/all",true,{root:true})
      return Promise.resolve(data);
    } catch (e) {
      return Promise.resolve(null);
    }
  },
  async destroy({dispatch}, payload){
    try {
      const data = await DeleteService(payload)
      dispatch("all",{id_padre: data.id_padre})
      dispatch("form_1617206897966/all", true,{root:true})
      return Promise.resolve(data)
    } catch (e) {
      return Promise.resolve(null)
    }
  }
};
